import { makeAutoObservable, runInAction } from "mobx";
import {
  clearPersistedStore,
  getPersistedStore,
  hydrateStore,
  makePersistable,
  pausePersisting,
  startPersisting,
  stopPersisting,
} from "mobx-persist-store";

export class MeetingDetailsStore {
  meeting = null;

  participants = null;

  comments = null;

  isJoined = false;

  isJoining = false;

  initLeaving = false;

  isLeaving = false;

  isLeft = false;

  joinProgress = 0;

  joinProgressLength = 0;

  leaveProgress = 0;

  joinError = false;

  audioMute = null;

  videoMute = null;

  userMediaPermissionsGranted = false;

  hasPermission = {};

  janusConfig = null;

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });

    makePersistable(this, {
      name: "MeetingDetailsStore",
      properties: [
        "meeting",
        "participants",
        "comments",
        "isJoined",
        "isJoining",
        "initLeaving",
        "isLeaving",
        "isLeft",
        "joinProgress",
        "joinProgressLength",
        "leaveProgress",
        "joinError",
        "audioMute",
        "videoMute",
        "userMediaPermissionsGranted",
        "hasPermission",
        "janusConfig",
      ],
      storage: sessionStorage,
    });
  }

  setJanusConfig(config) {
    this.janusConfig = config;
  }

  persistStore() {
    startPersisting(this);
  }

  pausePersist() {
    pausePersisting(this);
  }

  startPersist() {
    startPersisting(this);
  }

  disposePersist() {
    stopPersisting(this);
  }

  async clearPersistedData() {
    await clearPersistedStore(this);
  }

  async rehydrateStore() {
    await hydrateStore(this);
  }

  async getPersistedData() {
    const data = await getPersistedStore(this);

    alert(JSON.stringify(data));
  }

  async fetchMeetingDetails(meetingId, getMeetingDetails) {
    const data = await getMeetingDetails(meetingId);

    runInAction(() => {
      if (data) {
        console.log(data);
        this.meeting = data.workspace;
        this.participants = data.participants.rows;
        this.comments = data.comments?.rows;
      }
    });
  }

  updateMeetingStatus(status) {
    if (this.meeting) {
      this.meeting = { ...this.meeting, status };
    }
  }

  updateMeetingWorkspace(workspace) {
    if (this.meeting) {
      this.meeting = { ...this.meeting, ...workspace };
    }
  }

  updateParticipantsWithInvited(participant) {
    this.participants = [...this.participants, participant];
  }

  updateParticipantsWithStatusChanged({ status, pid }) {
    this.participants = this.participants.map((x) => (x.pid === pid ? { ...x, status } : x));
  }

  removeUninvitedParticipant({ pid }) {
    this.participants = this.participants.filter((x) => x.pid !== pid);
  }

  updateParticipantAudio({ mute, pid }) {
    this.participants = this.participants.map((x) => (x.pid === +pid ? { ...x, audio_mute: mute ? "muted" : "unmuted" } : x));
  }

  updateParticipantVideo({ mute, pid }) {
    this.participants = this.participants.map((x) => (x.pid === +pid ? { ...x, video_mute: mute ? "muted" : "unmuted" } : x));
  }

  increaseJoinProgress() {
    this.joinProgress += 1;
  }

  clearJoinProgress() {
    this.joinProgress = 0;
  }

  setJoinComplete() {
    this.isJoined = true;
    this.isJoining = false;
  }

  updateJoinedState(state) {
    this.isJoined = state;
  }

  updateInitLeaving(state) {
    this.initLeaving = state;
  }

  increaseLeaveProgress() {
    this.leaveProgress += 1;
    this.isLeaving = true;
  }

  setLeaveComplete() {
    this.isLeaving = false;
    this.isJoined = false;
    this.isLeft = true;
  }

  prepareForJoin(isJoining, joinProgressLength) {
    this.isJoining = isJoining;
    if (joinProgressLength) {
      // TODO: check the actual number joinProgressLength comes from the server to get a 100% loaded join progress bar
      //  - for the first time join we receive the 8 which is probably wrong and should be 7
      //  - for second time (after the successfully join) we receive the 15 (should be 14 based on feat description) which is probably wrong and
      // should be 9
      this.joinProgressLength = joinProgressLength === 8 ? 7 : joinProgressLength === 15 ? 9 : joinProgressLength;
    }
  }

  setIsLeaving(isLeaving) {
    this.isLeaving = isLeaving;
  }

  setIsLeft(isLeft) {
    this.isLeft = isLeft;
  }

  setJoinProgress(joinProgress) {
    this.joinProgress = joinProgress;
  }

  setLeaveProgress(leaveProgress) {
    this.leaveProgress = leaveProgress;
  }

  setJoinError(joinError) {
    this.joinError = joinError;
  }

  setAudioMute(mute) {
    this.audioMute = mute;
  }

  setVideoMute(mute) {
    this.videoMute = mute;
  }

  setIsUserMediaPermissionsGranted(userMediaPermissionsGranted) {
    this.userMediaPermissionsGranted = userMediaPermissionsGranted;
  }

  setHasPermission(hasPermission) {
    this.hasPermission = hasPermission;
  }

  reset() {
    console.log("RESET");
    this.meeting = null;
    this.participants = null;
    this.comments = null;
    this.isJoined = false;
    this.isJoining = false;
    this.initLeaving = false;
    this.isLeaving = false;
    this.isLeft = false;
    this.joinProgress = 0;
    this.leaveProgress = 0;
    this.joinError = false;
    this.audioMute = null;
    this.videoMute = null;
    this.userMediaPermissionsGranted = false;
    this.hasPermission = {};
  }
}
